import { z } from 'zod/v4'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const encryptionKeySchema = z.object({
    key: z.string(),
})

export const retrieveEncryptionKeyResponseSchema = z.object({
    data: encryptionKeySchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type RetrieveEncryptionKeyResponse = z.infer<typeof retrieveEncryptionKeyResponseSchema>
